// extracted by mini-css-extract-plugin
module.exports = {"root":"appbar-start-content_root__VJCG4","truncateLine":"appbar-start-content_truncateLine__h5iYt"};